export const SEND_FORM = 'SEND_FORM';
export const SET_FIELD_ACTIVATION_CODE = 'SET_FIELD_ACTIVATION_CODE';

export const SET_RESULT_OBJECT = 'SET_RESULT_OBJECT';
export const INIT_STATE = 'INIT_STATE';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/coupons/reducers/activatedCouponForm/actionsTypes.js